import { queryOptions } from '@tanstack/react-query';
import type { AdminRole, Tables } from '@nokowazzi/types';
import { apiFetch } from '../../lib/api';

export type AdminProductRow = Tables<'products'>;
export type AdminBannerRow = Tables<'banners'>;
export type AdminCategoryRow = Tables<'categories'>;

export interface AdminMeResponse {
  role: AdminRole;
}

/** GET /v1/admin/me — 가드·usePermissions가 공유하는 역할 캐시 */
export function adminMeQuery() {
  return queryOptions({
    queryKey: ['admin', 'me'] as const,
    queryFn: () => apiFetch<AdminMeResponse>('/v1/admin/me'),
    staleTime: 5 * 60_000,
    retry: false,
  });
}

/** 배열 응답과 { items } 응답 모두 수용 (어드민 계약 방어) */
function normalizeItems<T>(data: T[] | { items: T[] }): T[] {
  return Array.isArray(data) ? data : data.items;
}

export function adminCategoriesQuery() {
  return queryOptions({
    queryKey: ['admin', 'categories'] as const,
    queryFn: async () =>
      normalizeItems(
        await apiFetch<AdminCategoryRow[] | { items: AdminCategoryRow[] }>('/v1/admin/categories'),
      ),
  });
}

export function adminBannersQuery() {
  return queryOptions({
    queryKey: ['admin', 'banners'] as const,
    queryFn: async () =>
      normalizeItems(
        await apiFetch<AdminBannerRow[] | { items: AdminBannerRow[] }>('/v1/admin/banners'),
      ),
  });
}

export function adminProductQuery(id: string) {
  return queryOptions({
    queryKey: ['admin', 'products', 'detail', id] as const,
    queryFn: async () => {
      const data = await apiFetch<AdminProductRow | { item: AdminProductRow }>(
        `/v1/admin/products/${id}`,
      );
      return 'id' in data ? data : data.item;
    },
  });
}
